/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.IpRestrictions {
    "use strict";

    export class IpRestrictionsContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
        public internalRole: Model.DataDetail;
        public offsiteRole: Model.DataDetail;

        public userExclude: Model.DataDetail;
        public offsiteRolesListItems: Model.OffsiteRolesListItem[];
        public offsiteRoleItem: Model.OffsiteRolesListItem;

        public excludedUsersList: Model.DataDetail[];
        public searchResultItemTemplate = '{{storeName}}';


        public listBusinessIps: any = [];
        public roleModel: any;
        public internalRoleCriteria: any;
        public offsiteRoleCriteria: any;
        public userAtLocationID: any;
        public isIpAddressRequired: boolean;
        private auditNoun: Meevo.Model.NounEnum;

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            protected $http: angular.IHttpService,
            protected busyService: Meevo.Components.Busy.IBusyService) {

            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService);
            this.auditNoun = Meevo.Model.NounEnum.IpRestriction;
        }

        initializeContext(): void {
            this.baseEndpoint = this.appSettings.API_ENDPOINTS.ipRestriction;
            this.sectionTemplatePath = "app/plugins/ipRestrictions/sectionViews/";
            this.buildCrudSecurityKeysBase(this.securityKeys.MANAGEMENT_IPRESTRICTION_TAB_MAIN);
            this.entityType = 'ipRestrictions';
        }

        protected buildCrudSecurityKeysBase(baseKey, hasCreateKey = false, hasCopyKey = false) {
            this.editSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE;
            this.deleteSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_DELETE;
            this.addSecurityKey = "No Key";
            this.copySecurityKey = baseKey + ((hasCopyKey) ? Meevo.Components.Common.SecurityParts.KEY_PART_COPY : Meevo.Components.Common.SecurityParts.KEY_PART_WRITE);
        }

        initializeSections(): void {
            this.initializeContext();
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MANAGEMENT_IPRESTRICTION_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(0, "SECTION_SERVICES_MAIN", "main.html", true, false, this.appSettings.API_ENDPOINTS.ipRestriction,
                    "", this.loggingService, this.dataService, this.identityService, Meevo.Model.NounEnum.IpRestriction, null, this.securityKeys.MANAGEMENT_IPRESTRICTION_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            }
        }

        initializeHeader(model: any): void {
            this.headerContent = model.storeName;
            this.businessTypeDetail = model.businessTypeDetail;
            this.listBusinessIps = model.allowedIPs;
            this.roleModel = model;
            this.initializeCriteria(model);
        }

        initializeCriteria(model: any): void {
            var locationId = this.asLocationId ? this.asLocationId : this.itemId;
            this.isIpAddressRequired = false;
            this.internalRoleCriteria = this.identityService.current().centralOfficeId == locationId
                ? { coSearchResultFilter: 0, isCO: 1 } : {
                    locationId: locationId,
                    coSearchResultFilter: 1
                };

            this.offsiteRoleCriteria = {
                locationId: locationId
            };
        }

        showBusinessStaticIp(): void {
            this.roleModel = <Model.IpRestriction>this.selectedSection.model;
            this.roleModel.ipAddressItem.ipAddress = this.identityService.current().userHostAddress;
        }

        addBusinessIPs(item: Model.IpRestrictionItem, context: Model.IpRestriction): void {

            this.roleModel = <Model.IpRestriction>this.selectedSection.model;

            if (Model.Guard.isNothing(this.roleModel.coAllowedIPs)) {
                this.roleModel.coAllowedIPs = {};
            }
            if (Model.Guard.isNothing(this.roleModel.locationAllowedIPs)) {
                this.roleModel.locationAllowedIPs = {};
            }

            if (item.isForCoAccess) {

                if (item.ipAddress && _.find(this.roleModel.coAllowedIPs, (ec: any) => {
                    return ec.ipAddress === item.ipAddress;
                }) === undefined) {

                    this.roleModel.coAllowedIPs.push({ "displayName": item.displayName, "ipAddress": item.ipAddress, "isForCoAccess": item.isForCoAccess, "locationId": this.identityService.current().centralOfficeId, "itemId": this.itemId });
                }
            } else {
                if (item.ipAddress && _.find(this.roleModel.locationAllowedIPs, (ec: any) => {
                    return ec.ipAddress === item.ipAddress;
                }) === undefined) {

                    this.roleModel.locationAllowedIPs.push({ "displayName": item.displayName, "ipAddress": item.ipAddress, "locationId": (this.roleModel.id == this.identityService.current().centralOfficeId) ? null : this.itemId, "itemId": this.itemId });
                }
            }
            item.displayName = "";
            item.ipAddress = "";
            item.isForCoAccess = false;
        }

        removeBusinessIp(index: number, isCoIp: boolean): void {
            this.roleModel = <Model.IpRestriction>this.selectedSection.model;
            if (isCoIp) {
                this.roleModel.coAllowedIPs.splice(index, 1);

            } else {
                this.roleModel.locationAllowedIPs.splice(index, 1);
            }
        }


        addInternalOffsiteRoleMap(): void {
            this.roleModel = <Model.IpRestriction>this.selectedSection.model;
            if (Model.Guard.isNothing(this.roleModel.offsiteRoles)) {
                this.roleModel.offsiteRoles = [];
            }
            if (!Model.Guard.isNothing(this.internalRole.displayName) && !Model.Guard.isNothing(this.offsiteRole.displayName) &&
                _.find(this.roleModel.offsiteRoles, (ec: any) => {
                    return ec.internalRoleDisplayName === this.internalRole.displayName;
                }) === undefined) {

                var roleItem = {
                    "internalHomeLocationId": this.itemId,
                    "internalRoleId": this.internalRole.id,
                    "internalRoleDisplayName": this.internalRole.displayName,
                    "externalRoleId": this.offsiteRole.id,
                    "externalRoleDisplayName": this.offsiteRole.displayName
                };
                this.roleModel.offsiteRoles.push(roleItem);
                this.internalRole = "";
                this.offsiteRole = "";
            }
        }

        removeInternalOffsiteRoleMap(index: number): void {
            this.roleModel = <Model.IpRestriction>this.selectedSection.model;
            this.roleModel.offsiteRoles.splice(index, 1);
        }


        addUserToOverride(): void {
            this.roleModel = <Model.IpRestriction>this.selectedSection.model;

            if (Model.Guard.isNothing(this.roleModel.excludedUsers)) {
                this.roleModel.excludedUsers = [];
            }
            if (!Model.Guard.isNothing(this.userExclude.displayName) &&
                _.find(this.roleModel.excludedUsers,
                    (ec: any) => {
                        return ec.id === this.userExclude.id;
                    }) ===
                undefined) {

                this.roleModel.excludedUsers.push({ "displayName": this.userExclude.displayName, "id": this.userExclude.id, "locationId": this.itemId });
                this.userExclude = "";

            }

        }
        removeUserToOverride(index: number): void {
            this.roleModel = <Model.IpRestriction>this.selectedSection.model;
            this.roleModel.excludedUsers.splice(index, 1);
        }
        canEditIp(item: Model.IpRestrictionItem, isReadonly: boolean): boolean {
            var result = false;
            this.roleModel = <Model.IpRestriction>this.selectedSection.model;
            if (isReadonly)
                result = true;
            if (Model.Guard.isNothing(item.locationId) && this.roleModel.id != this.identityService.current().centralOfficeId) {
                result = true;
            }

            return result;
        }

        get showDelete(): boolean {
            return false;
        }
        get showCopy(): boolean {
            return false;
        }

        save(): angular.IPromise<any> {
            this.roleModel = <Model.IpRestriction>this.selectedSection.model;

            if (this.roleModel.objectState === 2026 &&
                this.roleModel.allowedIPs.length === 0 &&
                this.identityService.current().centralOfficeId.toString() === this.itemId.toString()) {
                this.busyService.stop();
                this.isIpAddressRequired = true;
                this.modalService.alert("MESSAGE_BUSINESSIP_REQUIRED_CO_ONLY", Components.Modal.ModalTranslationModes.Translate);
                return;
            }
            else
                return super.save();
        }
    }
}